<template>
  <v-btn
    icon
    small
    @click="updateItem"
    :color="item.is_omitted === true ? 'warning' : ''"
  >
    <v-icon small>fa-times-circle</v-icon>
  </v-btn>
</template>

<script>
import { api } from "@/api";
export default {
  name: "RecordCorrectionOmitEdit",
  props: {
    item: {
      required: true
    }
  },
  data() {
    return {
      dialog: false,
      comments: "",
      saving: false
    };
  },
  methods: {
    async updateItem() {
      try {
        this.saving = true;
        const data = {
          ...this.item,
          is_omitted: !this.item.is_omitted
        };
        await api.patchInventoryRecordsCorrections(this.item.id, data);
        this.$emit("update");
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style></style>
